<template>
  <div class="fire-check">
    <!-- 工单头部 -->
    <header class="fc-header">
      <div class="fc-header__top">
        <h1 class="fc-title">{{ wo.title }}</h1>
        <div class="fc-module">
          <i class="ri-stack-line"></i><span>{{ wo.module }}</span>
        </div>
      </div>
      <div class="fc-stats">
        <div class="fc-main-stats">
          <div class="fc-stat-card">
            <div class="fc-stat-label">
              <i class="ri-list-check-2"></i><span>检查项总数</span>
            </div>
            <div class="fc-stat-value">
              <span class="fc-num">{{ items.length }}</span
              ><span class="fc-unit">项</span>
            </div>
          </div>
          <div class="fc-stat-card">
            <div class="fc-stat-label">
              <i class="ri-error-warning-line"></i><span>发现问题总数</span>
            </div>
            <div class="fc-stat-value">
              <span class="fc-num">{{ issues.length }}</span
              ><span class="fc-unit">个</span>
            </div>
          </div>
        </div>
        <div class="fc-risk-stats">
          <div class="fc-risk-card fc-risk-high">
            <div class="fc-risk-label">
              <i class="ri-error-warning-line"></i><span>高风险问题</span>
            </div>
            <div class="fc-risk-num">{{ count("高") }}</div>
          </div>
          <div class="fc-risk-card fc-risk-mid">
            <div class="fc-risk-label">
              <i class="ri-alert-line"></i><span>中风险问题</span>
            </div>
            <div class="fc-risk-num">{{ count("中") }}</div>
          </div>
          <div class="fc-risk-card fc-risk-low">
            <div class="fc-risk-label">
              <i class="ri-checkbox-circle-line"></i><span>低风险问题</span>
            </div>
            <div class="fc-risk-num">{{ count("低") }}</div>
          </div>
        </div>
      </div>
    </header>

    <!-- 检查清单 -->
    <section class="fc-panel">
      <div class="fc-toolbar">
        <div class="fc-toolbar-title">
          <div class="fc-toolbar-title-row">
            <h2>
              <i class="ri-list-check-2"></i>检查清单<small
                >共 {{ items.length }} 项 · 按风险等级分组</small
              >
            </h2>
            <span v-if="issues.length" class="fc-submitted-tag"
              >已提 {{ issues.length }} 个问题</span
            >
          </div>
        </div>
        <div class="fc-toolbar-controls">
          <div class="fc-search">
            <i class="ri-search-line"></i>
            <input
              v-model.trim="query"
              type="text"
              placeholder="搜索检查项 / 内容 / 标准"
            />
          </div>
          <div class="fc-tabs">
            <button
              v-for="t in tabs"
              :key="t.v"
              @click="filter = t.v"
              :class="{ on: filter === t.v }"
            >
              {{ t.label }} <span>{{ t.n }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- 桌面端表格（按风险筛选） -->
      <div v-if="filter !== '全部'" class="fc-table-desktop">
        <div class="fc-risk-section">
          <div class="fc-risk-section-title">
            <span class="fc-dot" :class="filter"></span>
            <strong>{{
              filter === "高"
                ? "高风险检查项"
                : filter === "中"
                ? "中风险检查项"
                : "低风险检查项"
            }}</strong>
            <small
              >{{ shown.length }} 项 ·
              {{ filter === "高" ? "高风险项需重点核查" : "常规核查" }}</small
            >
          </div>
          <div class="fc-table-scroll">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>检查项</th>
                  <th>检查内容</th>
                  <th>检查标准</th>
                  <th>等级</th>
                  <th v-if="ticketStatus !== 'END'">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in shown" :key="x.id">
                  <td>{{ x.id }}</td>
                  <td>
                    <strong>{{ x.item }}</strong>
                  </td>
                  <td v-html="hl(x.content)"></td>
                  <td class="fc-standard" v-html="hlNl(x.standard)"></td>
                  <td>
                    <span class="fc-level" :class="x.level">{{ x.level }}</span>
                  </td>
                  <td v-if="ticketStatus !== 'END'">
                    <button class="fc-report" @click="open(x)">
                      <i class="ri-error-warning-line"></i>发现问题
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 桌面端分组 -->
      <div v-else class="fc-table-desktop">
        <div v-for="group in riskGroups" :key="group.level" class="fc-risk-section">
          <div class="fc-risk-section-title">
            <span class="fc-dot" :class="group.level"></span>
            <strong>{{ group.title }}</strong>
            <small>{{ group.items.length }} 项 · {{ group.tip }}</small>
          </div>
          <div class="fc-table-scroll">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>检查项</th>
                  <th>检查内容</th>
                  <th>检查标准</th>
                  <th>等级</th>
                  <th v-if="ticketStatus !== 'END'">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in group.items" :key="x.id">
                  <td>{{ x.id }}</td>
                  <td>
                    <strong>{{ x.item }}</strong>
                  </td>
                  <td v-html="hl(x.content)"></td>
                  <td class="fc-standard" v-html="hlNl(x.standard)"></td>
                  <td>
                    <span class="fc-level" :class="x.level">{{ x.level }}</span>
                  </td>
                  <td v-if="ticketStatus !== 'END'">
                    <button class="fc-report" @click="open(x)">
                      <i class="ri-error-warning-line"></i>发现问题
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 移动端卡片列表 -->
      <div class="fc-mobile-list">
        <template v-if="filter !== '全部'">
          <div class="fc-mobile-group-title">
            <span class="fc-dot" :class="filter"></span>
            <strong>{{
              filter === "高"
                ? "高风险检查项"
                : filter === "中"
                ? "中风险检查项"
                : "低风险检查项"
            }}</strong>
            <small
              >{{ shown.length }} 项 ·
              {{ filter === "高" ? "高风险项需重点核查" : "常规核查" }}</small
            >
          </div>
          <article v-for="x in shown" :key="x.id" class="fc-mobile-card" :class="x.level">
            <div class="fc-mobile-head">
              <span class="fc-mobile-index">{{ x.id }}</span>
              <strong>{{ x.item }}</strong>
              <span class="fc-level" :class="x.level">{{ x.level }}</span>
            </div>
            <div class="fc-mobile-row">
              <b>检查内容</b><span v-html="hl(x.content)"></span>
            </div>
            <div class="fc-mobile-row">
              <b>检查标准</b><span v-html="hlNl(x.standard)"></span>
            </div>
            <button v-if="ticketStatus !== 'END'" class="fc-report" @click="open(x)">
              <i class="ri-error-warning-line"></i>发现问题
            </button>
          </article>
        </template>
        <template v-else>
          <template v-for="group in riskGroups">
            <div :key="group.level" class="fc-mobile-group-title">
              <span class="fc-dot" :class="group.level"></span>
              <strong>{{ group.title }}</strong>
              <small>{{ group.items.length }} 项 · {{ group.tip }}</small>
            </div>
            <article
              v-for="x in group.items"
              :key="x.id"
              class="fc-mobile-card"
              :class="x.level"
            >
              <div class="fc-mobile-head">
                <span class="fc-mobile-index">{{ x.id }}</span>
                <strong>{{ x.item }}</strong>
                <span class="fc-level" :class="x.level">{{ x.level }}</span>
              </div>
              <div class="fc-mobile-row">
                <b>检查内容</b><span v-html="hl(x.content)"></span>
              </div>
              <div class="fc-mobile-row">
                <b>检查标准</b><span v-html="hlNl(x.standard)"></span>
              </div>
              <button v-if="ticketStatus !== 'END'" class="fc-report" @click="open(x)">
                <i class="ri-error-warning-line"></i>发现问题
              </button>
            </article>
          </template>
        </template>
      </div>
    </section>

    <!-- 已提交问题汇总 -->
    <section v-if="issues.length" class="fc-panel fc-summary">
      <div class="fc-summary-head">
        <div class="fc-summary-title">
          <i class="ri-error-warning-line"></i>
          <h2>已提交问题</h2>
        </div>
        <span class="fc-summary-stat">
          已提交 <b>{{ issues.length }}</b> 个问题
          <em class="fc-sep">|</em>
          <em class="fc-c-high">高 {{ count("高") }}</em>
          <em class="fc-c-mid">中 {{ count("中") }}</em>
          <em class="fc-c-low">低 {{ count("低") }}</em>
        </span>
        <span class="fc-summary-note">问题提交后只读展示，不可删除</span>
      </div>
      <div class="fc-issue-grid">
        <article v-for="i in issues" :key="i.id" class="fc-issue-card">
          <div class="fc-issue-top">
            <div class="fc-issue-badges">
              <span class="fc-badge" :class="i.level"
                ><i :class="riskIcon(i.level)"></i>{{ i.level }}</span
              >
              <span class="fc-issue-name">{{ i.checkItem }}</span>
              <a
                v-if="i.ticket_id && canOpenTicket"
                class="fc-chip fc-ticket-id"
                href="/todo-detail"
                @click.prevent="openTicket(i.ticket_id, $event)"
              >
                工单号：{{ i.ticket_id }}
              </a>
              <span v-else class="fc-chip fc-ticket-id"
                >工单号：{{ i.ticket_id || "-" }}</span
              >
              <span class="fc-chip">{{ i.type }}</span>
              <span class="fc-chip">{{ i.stage }}</span>
            </div>
            <span class="fc-issue-time">{{ i.time }}</span>
          </div>
          <p class="fc-issue-desc">{{ i.desc }}</p>
          <div v-if="i.roomNames && i.roomNames.length" class="fc-issue-rooms">
            <span class="fc-issue-rooms-label">涉及方仓：</span>
            <span v-for="r in i.roomNames" :key="r" class="fc-room-chip"
              ><i class="ri-door-line"></i>{{ r }}</span
            >
          </div>
          <div class="fc-issue-photos">
            <img
              v-for="(p, n) in i.photos"
              :key="n"
              :src="p"
              @click="preview(p)"
              alt="现场照片"
            />
            <span class="fc-photo-count">共 {{ i.photos.length }} 张现场照片</span>
            <span class="fc-done"><i class="ri-checkbox-circle-fill"></i>已提交</span>
          </div>
        </article>
      </div>

      <!-- 移动端已提交问题列表 -->
      <div class="fc-issue-mobile-list">
        <article
          v-for="i in issues"
          :key="i.id"
          class="fc-issue-mobile-card"
          :class="i.level"
        >
          <div class="fc-im-head">
            <span class="fc-dot" :class="i.level"></span>
            <strong>{{ i.checkItem }}</strong>
            <span class="fc-im-time">{{ i.time }}</span>
          </div>
          <div class="fc-im-fields">
            <div class="fc-im-field">
              <b>工单号</b>
              <a
                v-if="i.ticket_id && canOpenTicket"
                class="fc-ticket-link"
                href="/todo-detail"
                @click.prevent="openTicket(i.ticket_id, $event)"
              >
                {{ i.ticket_id }}
              </a>
              <span v-else>{{ i.ticket_id || "-" }}</span>
            </div>
            <div class="fc-im-field">
              <b>优先级</b><span class="fc-im-level" :class="i.level">{{ i.level }}</span>
            </div>
            <div class="fc-im-field">
              <b>问题类型</b><span>{{ i.type }}</span>
            </div>
            <div class="fc-im-field">
              <b>提交时间</b><span>{{ i.time }}</span>
            </div>
            <div class="fc-im-field">
              <b>关联内容</b
              ><span class="fc-im-chips"
                ><em>{{ i.type }}</em
                ><em>{{ i.stage }}</em></span
              >
            </div>
            <div class="fc-im-field">
              <b>问题描述</b><span class="fc-im-desc">{{ i.desc }}</span>
            </div>
            <div v-if="i.roomNames && i.roomNames.length" class="fc-im-field">
              <b>涉及方仓</b>
              <span class="fc-im-rooms"
                ><em v-for="r in i.roomNames" :key="r"
                  ><i class="ri-door-line"></i>{{ r }}</em
                ></span
              >
            </div>
            <div class="fc-im-field">
              <b>附件</b
              ><span class="fc-im-attach">共 {{ i.photos.length }} 张现场照片</span>
            </div>
          </div>
          <div v-if="i.photos.length" class="fc-im-photos">
            <img
              v-for="(p, n) in i.photos"
              :key="n"
              :src="p"
              @click="preview(p)"
              alt="现场照片"
            />
          </div>
          <div class="fc-im-foot">
            <span class="fc-done"><i class="ri-checkbox-circle-fill"></i>已提交</span>
          </div>
        </article>
      </div>
    </section>

    <!-- 问题录入弹窗 -->
    <div v-if="modal" class="fc-mask" @click.self="close">
      <div class="fc-modal">
        <header class="fc-modal-head">
          <b><i class="ri-error-warning-line"></i>发现问题录入</b>
          <button @click="close" aria-label="关闭"><i class="ri-close-line"></i></button>
        </header>
        <main class="fc-modal-body">
          <!-- 所选检查项 -->
          <div class="fc-selected">
            <span class="fc-selected-level" :class="form.checkLevel">
              <i :class="riskIcon(form.checkLevel)"></i>{{ form.checkLevel }}
            </span>
            <div class="fc-selected-copy">
              <strong>{{ form.checkItem }}</strong>
              <p>{{ form.checkContent }}</p>
            </div>
          </div>

          <!-- 校验错误汇总 -->
          <div v-if="errors.length" class="fc-errors">
            <div class="fc-errors-title">
              <i class="ri-error-warning-fill"></i>还有 {{ errors.length }} 项未完成
            </div>
            <ul>
              <li v-for="e in errors" :key="e.field">· {{ e.msg }}</li>
            </ul>
          </div>

          <!-- 方仓/房间 -->
          <div class="fc-field">
            <label
              >方仓/房间 <em>*</em><small>（单选，支持关键字查询）</small
              ><span v-if="form.room" class="fc-room-count">已选 1 个</span></label
            >
            <div class="fc-modal-search">
              <i class="ri-search-line"></i>
              <input
                v-model="roomQuery"
                type="text"
                placeholder="搜索方仓/房间名称，如 M03、消防设备间"
                :class="{ 'fc-invalid': fieldInvalid('room') }"
              />
            </div>
            <div v-if="roomChip" class="fc-room-chips">
              <span class="fc-room-chip-pick"
                >{{ roomChip
                }}<button @click="form.room = null" aria-label="取消选择">
                  <i class="ri-close-line"></i></button
              ></span>
            </div>
            <div class="fc-rooms" :class="{ 'fc-invalid': fieldInvalid('room') }">
              <div v-if="!filteredRooms.length" class="fc-rooms-empty">
                未找到匹配的方仓/房间
              </div>
              <label
                v-for="r in filteredRooms"
                :key="r"
                class="fc-room-item"
                :class="{ selected: form.room === r }"
              >
                <input
                  type="radio"
                  name="room-pick"
                  :checked="form.room === r"
                  @change="form.room = r"
                />
                <span class="fc-room-info">
                  <span class="fc-room-name">{{ r }}</span>
                </span>
                <i v-if="form.room === r" class="ri-check-line"></i>
              </label>
            </div>
          </div>

          <!-- 设备编号 -->
          <div class="fc-field">
            <label>设备编号 <em>*</em></label>
            <input
              v-model="form.deviceNumber"
              type="text"
              placeholder="请输入设备编号"
              class="fc-text-input"
              :class="{ 'fc-invalid': fieldInvalid('deviceNumber') }"
            />
          </div>

          <!-- 问题发现阶段 -->
          <div class="fc-field">
            <label>问题发现阶段 <em>*</em></label>
            <div class="fc-options" :class="{ 'fc-invalid': fieldInvalid('stage') }">
              <button
                v-for="x in stages"
                :key="x"
                @click="form.stage = x"
                :class="{ selected: form.stage === x }"
              >
                {{ x }}
              </button>
            </div>
          </div>

          <!-- 问题类型 -->
          <div class="fc-field">
            <label>问题类型 <em>*</em></label>
            <div class="fc-options" :class="{ 'fc-invalid': fieldInvalid('type') }">
              <button
                v-for="x in types"
                :key="x"
                @click="form.type = x"
                :class="{ selected: form.type === x }"
              >
                {{ x }}
              </button>
            </div>
          </div>

          <!-- 问题描述 -->
          <div class="fc-field">
            <label>问题描述 <em>*</em></label>
            <textarea
              v-model="form.desc"
              rows="3"
              placeholder="请描述现场发现的具体问题现象、位置及影响"
              :class="{ 'fc-invalid': fieldInvalid('desc') }"
            ></textarea>
          </div>

          <!-- 上传照片 -->
          <div class="fc-field">
            <label>上传照片 <em>*</em><small>（支持多选，至少 1 张）</small></label>
            <div class="fc-upload-line" :class="{ 'fc-invalid': fieldInvalid('photos') }">
              <el-upload
                action="/relay/cosfile/index"
                list-type="picture-card"
                accept="image/*"
                multiple
                :headers="headers"
                :file-list="photoFileList"
                :on-success="handlePhotoUploadSuccess"
                :on-error="handlePhotoUploadError"
                :on-remove="removePhoto"
                :on-preview="previewPhoto"
              >
                <i class="ri-image-add-line"></i>
              </el-upload>
              <span>已选 {{ form.photos.length }} 张</span>
            </div>
          </div>
        </main>
        <footer class="fc-modal-foot">
          <button class="fc-cancel" @click="close">取消</button>
          <button
            class="fc-submit"
            :disabled="submitting"
            :class="{ 'fc-loading': submitting }"
            @click="submit"
          >
            <i v-if="submitting" class="ri-loader-4-line fc-spin"></i>
            <i v-else class="ri-send-plane-line"></i>
            {{ submitting ? "提交中..." : "提交问题" }}
          </button>
        </footer>
      </div>
    </div>

    <div v-if="toast" class="fc-toast" :class="{ 'fc-toast-bottom': modal }">
      {{ toast }}
    </div>
  </div>
</template>

<script>
import {
  getDataByNbrokerUrl,
  getVariables,
  getTicketData,
  getTaskIdByTicketId,
} from "@/api/workBench/ticketApi.js";

export default {
  name: "FireCheck",
  props: {
    mozuName: {
      type: String,
      default: "",
    },
    ticketId: {
      type: String,
      default: "",
    },
    context: {
      type: Object,
      default: () => {},
    },
    funcroomList: {
      type: Array,
      default: () => [],
    },
    checkList: {
      type: Array,
      default: () => [],
    },
    problemData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      wo: {
        title: "数据中心消防设施接维查验",
        module: "",
      },
      stages: ["验证测试", "交付接维"],
      types: ["设备质量", "安装工艺", "设备调试", "规划设计", "其它"],
      rooms: [],
      items: [],
      filter: "全部",
      query: "",
      modal: false,
      toast: "",
      roomQuery: "",
      issues: [],
      errors: [],
      submitting: false,
      headers: {
        authToken:
          sessionStorage.getItem("AuthToken") || localStorage.getItem("AuthToken"),
      },
      user: this.$store?.state?.user?.name || sessionStorage.getItem("userid"),
      ServiceUrl: "http://ibroker-jiewei:8080/nBroker/api/v1/task",
      ticketStatus: "OPEN",
      form: {
        checkId: null,
        checkItem: "",
        checkContent: "",
        checkLevel: "",
        room: null,
        deviceNumber: "",
        stage: "",
        type: "",
        desc: "",
        photos: [],
      },
    };
  },
  computed: {
    tabs() {
      return ["全部", "高", "中", "低"].map((v) => ({
        v,
        label: v === "全部" ? "全部" : v + "风险",
        n:
          v === "全部"
            ? this.items.length
            : this.items.filter((x) => x.level === v).length,
      }));
    },
    riskGroups() {
      return [
        {
          level: "高",
          title: "高风险检查项",
          tip: "高风险项需重点核查",
          items: this.items.filter((x) => x.level === "高"),
        },
        {
          level: "中",
          title: "中风险检查项",
          tip: "中风险项常规核查",
          items: this.items.filter((x) => x.level === "中"),
        },
        {
          level: "低",
          title: "低风险检查项",
          tip: "低风险项常规核查",
          items: this.items.filter((x) => x.level === "低"),
        },
      ];
    },
    shown() {
      return this.items.filter(
        (x) =>
          (this.filter === "全部" || x.level === this.filter) &&
          `${x.item} ${x.content} ${x.standard}`
            .toLowerCase()
            .includes(this.query.toLowerCase())
      );
    },
    filteredRooms() {
      const kw = this.roomQuery.toLowerCase();
      return this.rooms.filter((x) => !kw || String(x).toLowerCase().includes(kw));
    },
    roomChip() {
      return this.form.room || "";
    },
    photoFileList() {
      return (this.form.photos || []).map((url, index) => ({
        name: `现场照片${index + 1}`,
        url,
      }));
    },
    canOpenTicket() {
      const host = window.location.host;
      return host.endsWith(".woa.com") || host.endsWith(".tencent.com");
    },
  },
  watch: {
    mozuName: {
      handler(val) {
        console.log(val, "mozu name ========");
        this.wo.module = val || "";
      },
      immediate: true,
    },
    ticketId(newVal) {
      console.log(newVal, "ticket id=====");
    },
    context: {
      async handler(obj) {
        console.log(obj, "context =====");
        console.log(obj?.ticketId, "ticketId ======");
        if (!obj?.ticketId) {
          await this.loadProblemData();
          return;
        }
        try {
          const result = await getTicketData(obj.ticketId);
          console.log(result, "ticketData ======");
          const list = result?.data?.List || [];
          const ticket = list[0];
          this.ticketStatus = ticket?.TicketStatus || "OPEN";
          await this.loadProblemData();
        } catch (error) {
          console.error(error, "get ticket data failed ======");
          await this.loadProblemData();
        }
      },
      immediate: true,
    },
    checkList: {
      handler(list) {
        console.log(list, "check list ==========");
        // 检查项：checkList 为后端下发的检查项数组，字段为
        // { id, check_item, check_content, check_standard, level }
        // 映射为页面内部使用的 { id, item, content, standard, level }
        this.items = (list || []).map((x) => ({
          id: x.id,
          item: x.check_item,
          content: x.check_content,
          standard: x.check_standard,
          level: x.level,
        }));
      },
      immediate: true,
    },
    funcroomList: {
      handler(list) {
        console.log(list, "funcroom list ==========");
        // 房间下拉：funcroomList 为纯字符串数组，需过滤掉 null / 空字符串
        this.rooms = (list || []).filter(
          (x) => x !== null && x !== undefined && String(x).trim() !== ""
        );
      },
      immediate: true,
    },
    problemData: {
      handler(list) {
        console.log(list, "problemData ====");
        this.mapProblemData(list);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    mapProblemData(list) {
      this.issues = (list || []).map((x) => ({
        id: x.id || x.ticket_id || "WT-" + Date.now(),
        ticket_id:
          x.ticket_id || x.ticketId || x.TicketId || x.sub_ticket_id?.TicketId || "",
        checkItem: x.checkItem || x.check_item || "",
        checkContent: x.checkContent || x.check_content || "",
        level: x.level || x.problem_level || "",
        stage: x.stage || x.problem_stage || "",
        type: x.type || x.problem_type || "",
        desc: x.desc || x.issue_description || "",
        roomNames: x.roomNames || (x.funcroom ? [x.funcroom] : []),
        photos: this.normalizePhotos(x.photos || x.problem_photo),
        time: x.time || "",
      }));
    },
    normalizePhotos(value) {
      if (!value) return [];
      let photos = value;
      if (typeof photos === "string") {
        try {
          photos = JSON.parse(photos);
        } catch (error) {
          photos = [];
        }
      }
      if (!Array.isArray(photos)) photos = [photos];
      return photos
        .map((p) => {
          if (typeof p === "string") return p;
          return p?.url || p?.URL || p?.response?.FileList?.[0]?.url || "";
        })
        .filter(Boolean);
    },
    async loadProblemData() {
      const instanceId = this.context?.instanceId;
      if (!instanceId) return;
      try {
        const result = await getVariables(["problem_data"], instanceId);
        console.log(result, "problem variables =====");
        const problemData = Array.isArray(result?.problem_data)
          ? result.problem_data
          : [];
        this.mapProblemData(problemData);
      } catch (error) {
        console.error(error, "load problem data failed");
      }
    },
    count(x) {
      return this.issues.filter((i) => this.riskKey(i.level) === x).length;
    },
    riskKey(level) {
      const v = String(level || "");
      if (v.includes("高")) return "高";
      if (v.includes("中")) return "中";
      if (v.includes("低")) return "低";
      return "低";
    },
    riskIcon(level) {
      const map = {
        高: "ri-error-warning-fill",
        中: "ri-alert-fill",
        低: "ri-information-fill",
      };
      return map[level] || "ri-information-fill";
    },
    esc(str) {
      if (str === null || str === undefined) return "";
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    highlight(text) {
      const safeText = this.esc(text);
      const kw = (this.query || "").trim();
      if (!kw) return safeText;
      const bs = String.fromCharCode(92);
      const specials = ".*+?^${}()|[]";
      let safeKw = this.esc(kw);
      for (let i = 0; i < specials.length; i++) {
        const ch = specials.charAt(i);
        safeKw = safeKw.split(ch).join(bs + ch);
      }
      try {
        return safeText.replace(new RegExp(safeKw, "gi"), function (m) {
          return '<mark class="hl">' + m + "</mark>";
        });
      } catch (e) {
        return safeText;
      }
    },
    hl(text) {
      return this.highlight(text);
    },
    hlNl(text) {
      return String(text)
        .split("\n")
        .map((line) => this.highlight(line))
        .join("<br>");
    },
    fieldInvalid(field) {
      return this.errors.some((e) => e.field === field);
    },
    open(x) {
      this.form = {
        checkId: x.id,
        checkItem: x.item,
        checkContent: x.content,
        checkLevel: x.level,
        room: null,
        deviceNumber: "",
        stage: "",
        type: "",
        desc: "",
        photos: [],
      };
      this.errors = [];
      this.roomQuery = "";
      this.modal = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.modal = false;
      document.body.style.overflow = "";
    },
    handlePhotoUploadSuccess(response, file, fileList) {
      file.response = response;
      this.form.photos = fileList.map((item) => this.photoUrl(item)).filter((url) => url);
    },
    handlePhotoUploadError() {
      this.show("照片上传失败");
    },
    removePhoto(file, fileList) {
      this.form.photos = fileList.map((item) => this.photoUrl(item)).filter((url) => url);
    },
    previewPhoto(file) {
      const url = this.photoUrl(file);
      if (url) this.preview(url);
    },
    photoUrl(file) {
      return file?.response?.FileList?.[0]?.url || file?.url || "";
    },
    submit() {
      if (this.submitting) return;
      const errs = [];
      if (!this.form.room) errs.push({ field: "room", msg: "请选择一个方仓/房间" });
      if (!this.form.deviceNumber.trim())
        errs.push({ field: "deviceNumber", msg: "请输入设备编号" });
      if (!this.form.stage) errs.push({ field: "stage", msg: "请选择问题发现阶段" });
      if (!this.form.type) errs.push({ field: "type", msg: "请选择问题类型" });
      if (!this.form.desc.trim()) errs.push({ field: "desc", msg: "请填写问题描述" });
      if (!this.form.photos.length)
        errs.push({ field: "photos", msg: "请至少上传 1 张现场照片" });
      this.errors = errs;
      if (errs.length) {
        this.show("请完成所有必填项");
        return;
      }

      const issue = {
        id: "WT-" + Date.now(),
        ticket_id: "",
        checkItem: this.form.checkItem,
        checkContent: this.form.checkContent,
        level: this.form.checkLevel,
        problem_level: this.form.checkLevel,
        stage: this.form.stage,
        type: this.form.type,
        desc: this.form.desc.trim(),
        roomNames: this.form.room ? [this.form.room] : [],
        photos: [...this.form.photos],
        time: this.fmtTime(),
      };

      // 第一次调用：create_problem_ticket（单条问题）
      const createParams = {
        context: {
          method_name: "create_problem_ticket",
          ...this.context,
        },
        args: {
          problem_data: {
            check_item: this.form.checkItem,
            check_content: this.form.checkContent,
            problem_level: this.form.checkLevel,
            problem_stage: this.form.stage,
            problem_type: this.form.type,
            issue_description: this.form.desc.trim(),
            device_number: this.form.deviceNumber.trim(),
            device_type: this.form.checkItem,
            major: "消防",
            photos: this.form.photos
              .map((url, index) => ({
                name: `问题照片${index + 1}`,
                url,
              }))
              .filter((photo) => photo.url),
            funcroom: this.form.room,
          },
          funcroom: this.form.room,
          process_user: this.user,
        },
      };

      this.submitting = true;
      getDataByNbrokerUrl(createParams, this.ServiceUrl)
        .then((result) => {
          issue.ticket_id = result?.data?.result?.sub_ticket_id?.TicketId || "";
          const allIssues = [...this.issues, issue];
          const updateParams = {
            context: {
              ...this.context,
              method_name: "update",
            },
            args: {
              process_data: {
                problem_data: allIssues.map((it) => ({
                  ticket_id: it.ticket_id || "",
                  check_item: it.checkItem || "",
                  check_content: it.checkContent || "",
                  problem_level: it.problem_level || it.level || "",
                  problem_stage: it.stage || "",
                  problem_type: it.type || "",
                  issue_description: it.desc || "",
                  funcroom: (it.roomNames && it.roomNames[0]) || "",
                  problem_photo: Array.isArray(it.photos)
                    ? it.photos.map((url, idx) => ({ name: `问题照片${idx + 1}`, url }))
                    : [],
                })),
              },
              process_user: this.user,
            },
          };
          return getDataByNbrokerUrl(updateParams, this.ServiceUrl);
        })
        .then(() => {
          this.issues.unshift(issue);
          this.$emit("problemData", this.issues);
          this.close();
          this.show("问题已提交");
        })
        .catch(() => this.show("问题提交失败"))
        .finally(() => {
          this.submitting = false;
        });
    },
    fmtTime(d) {
      const t = d || new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())} ${p(
        t.getHours()
      )}:${p(t.getMinutes())}`;
    },
    show(x) {
      this.toast = x;
      clearTimeout(this._timer);
      this._timer = setTimeout(() => (this.toast = ""), 2200);
    },
    async openTicket(ticketId, event) {
      if (event) event.preventDefault();
      if (!ticketId) return;

      const { host, origin } = window.location;
      let url = "";
      if (host.endsWith(".woa.com")) {
        url = `${origin}/operateManage/business/ToDoDetails?params=${encodeURIComponent(
          ticketId
        )}`;
      } else if (host.endsWith(".tencent.com")) {
        url = `${origin}/operateManage/business/details?params=${encodeURIComponent(
          ticketId
        )}`;
      } else {
        try {
          const taskId = await getTaskIdByTicketId(ticketId);
          console.log("工单跳转结果:", { ticketId, taskId });
          if (!taskId) {
            this.show("未获取到工单任务ID，无法跳转");
            return;
          }
          url = `${origin}/todo-detail-new?ticketId=${encodeURIComponent(
            ticketId
          )}&taskId=${encodeURIComponent(taskId)}`;
        } catch (error) {
          console.error("获取工单任务ID失败:", error);
          this.show("获取工单任务ID失败，无法跳转");
          return;
        }
      }

      window.open(url, "_blank");
    },
    preview(x) {
      const w = window.open("");
      if (w) {
        w.document.write(
          `<title>现场照片</title><body style="margin:0;display:flex;align-items:center;justify-content:center;background:#0f172a;height:100vh"><img src="${x}" style="max-width:100%;max-height:100%;object-fit:contain"/></body>`
        );
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = "";
  },
};
</script>
<style scoped>
@import url("https://cdn.jsdelivr.net/npm/remixicon@3.5.0/fonts/remixicon.css");

/* ============ 根容器：与全局样式隔离 ============ */
.fire-check {
  width: 100%;
  min-height: 100vh;
  max-width: 1600px;
  margin: 0 auto;
  padding: 16px 12px 24px;
  box-sizing: border-box;
  background: #f8fafc;
  color: #334155;
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  line-height: 1.5;
}
.fire-check *,
.fire-check *::before,
.fire-check *::after {
  box-sizing: border-box;
}
.fire-check i {
  display: inline-block;
  font-style: normal;
}
.fire-check h1,
.fire-check h2,
.fire-check h3,
.fire-check p,
.fire-check ul {
  margin: 0;
}
.fire-check button {
  font-family: inherit;
  cursor: pointer;
}
.fire-check button,
.fire-check label,
.fire-check input,
.fire-check textarea {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
/* 抵消全局 label { font-weight: 700 } 污染：本页面的 label 一律按需设置字重 */
.fire-check label {
  font-weight: 400;
}

/* ============ 头部 ============ */
.fc-header {
  border-radius: 16px;
  color: #fff;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.1);
  background: linear-gradient(120deg, #274cd1 0%, #3545d9 50%, #443de0 100%);
}
.fc-title {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.35;
}
.fc-module {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.15);
  font-size: 13px;
  font-weight: 500;
}
.fc-stats {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.fc-main-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.fc-stat-card {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.15);
  padding: 11px 16px;
  min-width: 0;
}
.fc-stat-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
}
.fc-stat-label i {
  color: rgba(255, 255, 255, 0.75);
}
.fc-stat-value {
  margin-top: 4px;
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.fc-num {
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
}
.fc-unit {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}
.fc-risk-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}
.fc-risk-card {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.07);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  min-width: 0;
}
.fc-risk-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
}
.fc-risk-label i {
  color: rgba(255, 255, 255, 0.75);
}
.fc-risk-high .fc-risk-label,
.fc-risk-high .fc-risk-num {
  color: #fecaca;
}
.fc-risk-mid .fc-risk-label,
.fc-risk-mid .fc-risk-num {
  color: #fde68a;
}
.fc-risk-low .fc-risk-label,
.fc-risk-low .fc-risk-num {
  color: #a7f3d0;
}
.fc-risk-num {
  margin-top: 2px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

/* ============ 面板 ============ */
.fc-panel {
  margin-top: 16px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}

/* ============ 工具栏 ============ */
.fc-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}
.fc-toolbar-title {
  min-width: 0;
}
.fc-toolbar-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.fc-toolbar-title h2 {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #1e293b;
  font-size: 17px;
  font-weight: 700;
}
.fc-toolbar-title h2 i {
  color: #6366f1;
}
.fc-toolbar-title h2 small {
  color: #64748b;
  font-size: 12px;
  font-weight: 400;
}
.fc-submitted-tag {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  background: #fef2f2;
  color: #dc2626;
  font-size: 12px;
  font-weight: 600;
}
.fc-toolbar-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.fc-search {
  position: relative;
  flex: 0 1 280px;
  min-width: 220px;
}
.fc-search i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  pointer-events: none;
}
.fc-search input {
  display: block;
  width: 100%;
  height: 36px;
  margin: 0;
  padding: 8px 12px 8px 34px;
  border: 1px solid #dbe3ef;
  border-radius: 6px;
  outline: none;
  font-size: 13px;
  color: #334155;
  background: #fff;
}
.fc-search input:focus {
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.12);
}
.fc-tabs {
  display: flex;
  gap: 2px;
  padding: 3px;
  border: 1px solid #dbe3ef;
  border-radius: 7px;
  background: #f8fafc;
  white-space: nowrap;
}
.fc-tabs button {
  min-width: 62px;
  height: 30px;
  padding: 5px 8px;
  border: 1px solid transparent;
  border-radius: 5px;
  background: transparent;
  color: #64748b;
  font-size: 13px;
}
.fc-tabs button span {
  margin-left: 3px;
  color: #94a3b8;
}
.fc-tabs button.on {
  border-color: #c7d2fe;
  color: #4338ca;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
  font-weight: 600;
}
.fc-tabs button.on span {
  color: #6366f1;
}

/* ============ 表格 ============ */
.fc-table-desktop {
  margin-top: 16px;
}
.fc-table-scroll {
  overflow-x: auto;
}
.fc-table-scroll table {
  width: 100%;
  min-width: 1180px;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 13px;
}
.fc-table-scroll th,
.fc-table-scroll td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
  vertical-align: top;
  word-break: break-word;
}
.fc-table-scroll th {
  padding: 10px 12px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.fc-table-scroll td {
  line-height: 1.65;
  color: #334155;
}
.fc-table-scroll tbody tr:hover td {
  background: #fafbff;
}
.fc-table-scroll th:first-child,
.fc-table-scroll td:first-child {
  width: 64px;
}
.fc-table-scroll th:nth-child(2),
.fc-table-scroll td:nth-child(2) {
  width: 190px;
}
.fc-table-scroll th:nth-child(3),
.fc-table-scroll td:nth-child(3) {
  width: 330px;
}
.fc-table-scroll th:nth-child(4),
.fc-table-scroll td:nth-child(4) {
  width: 430px;
}
.fc-table-scroll th:nth-child(5),
.fc-table-scroll td:nth-child(5) {
  width: 76px;
}
.fc-table-scroll th:nth-child(6),
.fc-table-scroll td:nth-child(6) {
  width: 120px;
}
.fc-table-scroll td strong {
  color: #1e293b;
  font-weight: 600;
}
.fc-standard {
  white-space: normal;
  color: #64748b;
}

/* 关键词高亮 */
.fire-check mark.hl {
  background-color: #fef08a;
  color: #78350f;
  padding: 0 2px;
  border-radius: 2px;
  font-weight: 600;
}

/* ============ 风险分组 ============ */
.fc-risk-section + .fc-risk-section {
  margin-top: 26px;
}
.fc-risk-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 0 10px;
  border-bottom: 2px solid #e8edf5;
  color: #334155;
}
.fc-risk-section-title strong {
  font-size: 14px;
  font-weight: 600;
}
.fc-risk-section-title small {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 400;
}
.fc-dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
}
.fc-dot.高 {
  background: #ef4444;
}
.fc-dot.中 {
  background: #f59e0b;
}
.fc-dot.低 {
  background: #10b981;
}

/* 等级徽标 */
.fc-level {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}
.fc-level.高 {
  color: #fff;
  background: #ef4444;
}
.fc-level.中 {
  color: #fff;
  background: #f59e0b;
}
.fc-level.低 {
  color: #fff;
  background: #10b981;
}

/* 发现问题按钮 */
.fc-report {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 9px;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  color: #2563eb;
  background: #eff6ff;
  font-size: 12px;
  white-space: nowrap;
}
.fc-report:hover {
  background: #dbeafe;
}
.fc-report:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
} /* ============ 移动端卡片列表 ============ */
.fc-mobile-list {
  display: none;
}

/* ============ 已提交问题汇总 ============ */
.fc-summary-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}
.fc-summary-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.fc-summary-title > i {
  color: #ef4444;
  font-size: 20px;
}
.fc-summary-title h2 {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
}
.fc-summary-stat {
  color: #475569;
  font-size: 13px;
}
.fc-summary-stat b {
  color: #1e293b;
  font-weight: 700;
}
.fc-sep {
  margin: 0 6px;
  color: #cbd5e1;
  font-style: normal;
}
.fc-c-high {
  color: #dc2626;
  font-style: normal;
  margin: 0 6px;
}
.fc-c-mid {
  color: #d97706;
  font-style: normal;
  margin: 0 6px;
}
.fc-c-low {
  color: #059669;
  font-style: normal;
  margin: 0 6px;
}
.fc-summary-note {
  color: #94a3b8;
  font-size: 12px;
}
.fc-issue-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  margin-top: 16px;
}
.fc-issue-mobile-list {
  display: none;
}
.fc-issue-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}
.fc-issue-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.fc-issue-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}
.fc-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}
.fc-badge.高 {
  background: #ef4444;
}
.fc-badge.中 {
  background: #f59e0b;
}
.fc-badge.低 {
  background: #10b981;
}
.fc-issue-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}
.fc-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 12px;
}
.fc-issue-time {
  color: #94a3b8;
  font-size: 12px;
  white-space: nowrap;
}
.fc-ticket-id,
.fc-ticket-link {
  color: #2563eb;
  cursor: pointer;
  text-decoration: none;
}
.fc-ticket-id:hover,
.fc-ticket-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.fc-issue-ticket {
  margin-top: 10px;
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  word-break: break-all;
}
.fc-issue-desc {
  margin-top: 10px;
  color: #475569;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
}
.fc-issue-rooms {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.fc-issue-rooms-label {
  color: #64748b;
  font-size: 12px;
}
.fc-room-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 12px;
}
.fc-issue-photos {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  flex-wrap: wrap;
}
.fc-issue-photos img {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #e2e8f0;
  cursor: pointer;
}
.fc-photo-count {
  color: #94a3b8;
  font-size: 12px;
}
.fc-done {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #059669;
  font-size: 12px;
  font-weight: 600;
}

/* ============ 弹窗 ============ */
.fc-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.55);
}
.fc-modal {
  width: 100%;
  max-width: 680px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.35);
  overflow: hidden;
}
.fc-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}
.fc-modal-head b {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}
.fc-modal-head b i {
  color: #ef4444;
}
.fc-modal-head button {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  font-size: 18px;
}
.fc-modal-head button:hover {
  background: #f1f5f9;
  color: #475569;
}
.fc-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}
.fc-selected {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.fc-selected-level {
  flex-shrink: 0;
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}
.fc-selected-level.高 {
  background: #ef4444;
}
.fc-selected-level.中 {
  background: #f59e0b;
}
.fc-selected-level.低 {
  background: #10b981;
}
.fc-selected-copy strong {
  font-size: 14px;
  color: #1e293b;
}
.fc-selected-copy p {
  margin-top: 2px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

.fc-errors {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
}
.fc-errors-title {
  color: #dc2626;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.fc-errors ul {
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
  color: #dc2626;
  font-size: 12px;
}
.fc-errors li {
  line-height: 1.7;
}

.fc-field {
  margin-top: 16px;
}
.fc-field > label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}
.fc-field > label em {
  color: #dc2626;
  font-style: normal;
}
.fc-field > label small {
  color: #94a3b8;
  font-weight: 400;
  font-size: 12px;
}
.fc-room-count {
  margin-left: auto;
  color: #059669;
  font-size: 12px;
  font-weight: 500;
}
.fc-modal-search {
  position: relative;
  margin-bottom: 8px;
}
.fc-modal-search i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  pointer-events: none;
}
.fc-modal-search input {
  display: block;
  width: 100%;
  height: 36px;
  margin: 0;
  padding: 8px 12px 8px 34px;
  border: 1px solid #dbe3ef;
  border-radius: 6px;
  outline: none;
  font-size: 13px;
  color: #334155;
  background: #fff;
}
.fc-modal-search input:focus {
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.12);
}
.fc-room-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.fc-room-chip-pick {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 12px;
}
.fc-room-chip-pick button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  background: rgba(67, 56, 202, 0.15);
  color: #4338ca;
  font-size: 12px;
  line-height: 1;
}
.fc-rooms {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  max-height: 140px;
  overflow-y: auto;
  padding: 2px;
  border: 1px solid transparent;
  border-radius: 8px;
}
.fc-rooms-empty {
  grid-column: 1 / -1;
  padding: 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}
.fc-room-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  min-width: 0;
  font-weight: 400;
}
.fc-room-item:hover {
  border-color: #c7d2fe;
  background: #fafbff;
}
.fc-room-item.selected {
  border-color: #6366f1;
  background: #eef2ff;
}
.fc-room-item input {
  flex-shrink: 0;
  margin: 0;
  cursor: pointer;
}
.fc-room-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.fc-room-name {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fc-room-sub {
  font-size: 12px;
  color: #94a3b8;
}
.fc-room-item > i {
  margin-left: auto;
  color: #6366f1;
}

.fc-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.fc-options button {
  padding: 7px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #fff;
  color: #475569;
  font-size: 13px;
}
.fc-options button:hover {
  border-color: #c7d2fe;
  color: #4338ca;
}
.fc-options button.selected {
  border-color: #6366f1;
  background: #eef2ff;
  color: #4338ca;
  font-weight: 600;
}

.fc-field textarea {
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #dbe3ef;
  border-radius: 6px;
  outline: none;
  resize: vertical;
  font-size: 13px;
  color: #334155;
  font-family: inherit;
  line-height: 1.6;
}
.fc-field textarea:focus {
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.12);
}

.fc-field input.fc-text-input {
  display: block;
  width: 100%;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid #dbe3ef;
  border-radius: 6px;
  outline: none;
  font-size: 13px;
  color: #334155;
  font-family: inherit;
  line-height: 1.6;
  background: #fff;
}
.fc-field input.fc-text-input:focus {
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.12);
}

.fc-upload-line {
  display: flex;
  align-items: center;
  gap: 12px;
}
.fc-upload-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
}
.fc-upload-button input {
  display: none;
}
.fc-upload-line > span {
  color: #64748b;
  font-size: 13px;
}
.fc-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(76px, 1fr));
  gap: 8px;
  margin-top: 10px;
}
.fc-preview-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}
.fc-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.fc-preview-item button {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.6);
  color: #fff;
  font-size: 12px;
}

/* 校验失败红框 */
.fire-check .fc-invalid {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12) !important;
}

.fc-modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #f1f5f9;
}
.fc-cancel {
  padding: 8px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
}
.fc-cancel:hover {
  background: #f8fafc;
}
.fc-submit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: none;
  border-radius: 8px;
  background: #1e293b;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.fc-submit:hover {
  background: #0f172a;
}
.fc-submit:disabled,
.fc-submit.fc-loading {
  cursor: not-allowed;
  opacity: 0.7;
}
.fc-submit.fc-loading {
  pointer-events: none;
}
.fc-spin {
  display: inline-block;
  animation: fc-spin 1s linear infinite;
}
@keyframes fc-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* ============ Toast ============ */
.fc-toast {
  position: fixed;
  left: 50%;
  bottom: 48px;
  transform: translateX(-50%);
  z-index: 10000;
  padding: 9px 20px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.9);
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.3);
  animation: fc-fade 0.2s ease;
}
.fc-toast-bottom {
  bottom: 140px;
}
@keyframes fc-fade {
  from {
    opacity: 0;
    transform: translate(-50%, 6px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

/* ============ 移动端适配 ============ */
/* 断点 760px：本页面已通过 .postcssrc.js 的 exclude 按文件路径整体排除 rem 转换，
   故此处直接写原始 px，与源项目一致，无需 rem 等价值。 */
@media (max-width: 760px) {
  .fire-check {
    padding: 12px 10px 20px;
  }
  .fc-title {
    font-size: 20px;
  }
  .fc-num {
    font-size: 30px;
  }
  .fc-main-stats {
    gap: 8px;
  }
  .fc-stat-card {
    padding: 10px 12px;
  }
  .fc-risk-stats {
    gap: 8px;
  }
  .fc-risk-card {
    padding: 8px 10px;
  }
  .fc-risk-label {
    font-size: 11px;
  }
  .fc-risk-num {
    font-size: 20px;
  }
  .fc-toolbar {
    flex-direction: column;
    gap: 12px;
  }
  .fc-toolbar-controls {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .fc-search {
    flex: none;
    width: 100%;
    min-width: 0;
  }
  .fc-tabs {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
  .fc-tabs button {
    min-width: 0;
  }
  /* 移动端隐藏表格，显示卡片 */
  .fc-table-desktop {
    display: none;
  }
  .fc-mobile-list {
    display: block;
    margin-top: 16px;
  }
  .fc-mobile-group-title {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 0;
    margin-top: 8px;
    border-bottom: 2px solid #e8edf5;
    color: #334155;
  }
  .fc-mobile-group-title strong {
    font-size: 14px;
    font-weight: 600;
  }
  .fc-mobile-group-title small {
    color: #94a3b8;
    font-size: 12px;
  }
  .fc-mobile-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    margin-top: 10px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  }
  .fc-mobile-card.高 {
    border-left: 3px solid #ef4444;
  }
  .fc-mobile-card.中 {
    border-left: 3px solid #f59e0b;
  }
  .fc-mobile-card.低 {
    border-left: 3px solid #10b981;
  }
  .fc-mobile-head {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .fc-mobile-index {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 5px;
    border-radius: 6px;
    background: #f1f5f9;
    color: #64748b;
    font-size: 12px;
  }
  .fc-mobile-head strong {
    flex: 1;
    min-width: 0;
    color: #1e293b;
    font-size: 14px;
  }
  .fc-mobile-row {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.6;
  }
  .fc-mobile-row b {
    flex-shrink: 0;
    color: #94a3b8;
    font-weight: 500;
  }
  .fc-mobile-row span {
    color: #475569;
  }
  .fc-mobile-card .fc-report {
    margin-top: 10px;
    width: 100%;
  }
  /* 弹窗移动端 */
  .fc-mask {
    padding: 0;
    align-items: flex-end;
  }
  .fc-modal {
    max-width: none;
    max-height: 92vh;
    border-radius: 16px 16px 0 0;
  }
  .fc-rooms {
    grid-template-columns: 1fr;
  }
  /* 移动端隐藏桌面网格卡片，显示字段式卡片 */
  .fc-issue-grid {
    display: none;
  }
  .fc-issue-mobile-list {
    display: block;
    margin-top: 16px;
  }
  .fc-issue-mobile-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px;
    margin-top: 10px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  }
  .fc-issue-mobile-card.高 {
    border-left: 3px solid #ef4444;
  }
  .fc-issue-mobile-card.中 {
    border-left: 3px solid #f59e0b;
  }
  .fc-issue-mobile-card.低 {
    border-left: 3px solid #10b981;
  }
  .fc-im-head {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .fc-im-head strong {
    flex: 1;
    min-width: 0;
    color: #1e293b;
    font-size: 15px;
    font-weight: 600;
  }
  .fc-im-time {
    color: #94a3b8;
    font-size: 12px;
    white-space: nowrap;
  }
  .fc-im-fields {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .fc-im-field {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    line-height: 1.6;
  }
  .fc-im-field > b {
    flex-shrink: 0;
    min-width: 64px;
    color: #94a3b8;
    font-weight: 500;
  }
  .fc-im-field > span {
    color: #334155;
    min-width: 0;
  }
  .fc-im-level {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    padding: 1px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
  }
  .fc-im-level.高 {
    background: #ef4444;
  }
  .fc-im-level.中 {
    background: #f59e0b;
  }
  .fc-im-level.低 {
    background: #10b981;
  }
  .fc-im-chips {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .fc-im-chips em {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    background: #f1f5f9;
    color: #475569;
    font-size: 12px;
    font-style: normal;
  }
  .fc-im-desc {
    white-space: pre-wrap;
  }
  .fc-im-rooms {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .fc-im-rooms em {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 6px;
    background: #eef2ff;
    color: #4338ca;
    font-size: 12px;
    font-style: normal;
  }
  .fc-im-attach {
    color: #64748b;
  }
  .fc-im-photos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }
  .fc-im-photos img {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #e2e8f0;
    cursor: pointer;
  }
  .fc-im-foot {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f1f5f9;
  }
}
</style>
